<script setup lang="ts">
import UiCta from '@/components/common/UiCta.vue'
import { useI18n } from 'vue-i18n'

import ColorProfilePicker from './ColorProfilePicker.vue'
import DarkToggle from './DarkToggle.vue'
import LanguageSwitcher from './LanguageSwitcher.vue'

const emit = defineEmits<{
  (e: 'interact'): void
}>()

const { t } = useI18n()

function handleInteract() {
  emit('interact')
}
</script>

<template>
  <div
    class="utility-control ml-auto mr-0"
    @pointerdown.capture="handleInteract"
    @focusin.capture="handleInteract"
  >
    <LanguageSwitcher />
    <ColorProfilePicker />
    <DarkToggle />
    <UiCta
      class="hidden lg:inline-flex"
      :options="{
        type: 'external',
        text: t('cta.login'),
        icon: 'UserCog',
        color: 'primary',
        to: 'https://my.fitnessroom.no/pages/login',
        utm: {
          utm_source: 'header_navigation',
          utm_medium: 'webpage',
          utm_campaign: 'member_login'
        }
      }"
    />
  </div>
</template>
